import React, { useEffect, useState } from "react";
import HeroBanner from "./Hero Banner/banner";
import Cashflow from "./Cashflow/cash-flow";
import "./invitsValuation.less";
import service from "../../../services/service";
import { Invit } from "../../../types/invit.types";
import { useParameters } from "../../../context/parametersContext";
import { useParams } from "react-router-dom";

const InvITsValuation: React.FC = () => {

  const [invitsData, setInvitsData] = useState<Invit[]>([]);
  const [selectedInvit, setSelectedInvit] = useState<Invit | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  const { id } = useParams();

  const { activeToggle } = useParameters();

  useEffect(() => {
    fetchInvitsData();
  }, [activeToggle]);

  const fetchInvitsData = async () => {
    try {
      setLoading(true);
      const isPublic = activeToggle === "Public";
      const data = await service.getInvitsOperational(isPublic);

      if (data && Array.isArray(data) && data.length > 0) {
        setInvitsData(data);

        const found = data.find((item) => item._id === id);

        setSelectedInvit(found || data[0]);
      } else {
        setError("No InvITs data available");
      }
    } catch (err) {
      console.error("Error fetching InvITs data:", err);
      setError("Failed to load InvITs data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="invit-valuation">
        <div className="loading-container">
          <p>Loading InvITs data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="invit-valuation">
        <div className="error-container">
          <p>{error}</p>
          <button onClick={fetchInvitsData}>Retry</button>
        </div>
      </div>
    );
  }

  if (!selectedInvit) {
    return (
      <div className="invit-valuation">
        <div className="error-container">
          <p>No InvIT selected</p>
        </div>
      </div>
    );
  }

  return (
    <div className="invit-valuation">
      <HeroBanner invitData={selectedInvit} />

      <Cashflow
        invitsData={invitsData}
        selectedInvit={selectedInvit}
        onInvitChange={setSelectedInvit}
      />
    </div>
  );
};

export default InvITsValuation;
